<template>
  <div class="importer-content">
    <iframe
      :src="esignUrl"
      ref="frame"
      @load="iframeUrlChanged"
      class="esign-iframe"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      test: 'test',
      esignUrl:
        this.$route.params.esignUrl || process.env.VUE_APP_DRIP_PORTAL_HOST,
      doEsign: false,
      loading: false
    }
  },
  computed: {
    redirectUrl() {
      return process.env.VUE_APP_DRIP_PORTAL_HOST
    }
  },
  methods: {
    iframeUrlChanged() {
      try {
        if (
          this.$refs.frame.contentWindow.location.href.indexOf(
            this.redirectUrl
          ) === 0
        ) {
          this.$notify({
            title: this.$t('notifications.importers.title'),
            text: this.$t('notifications.importers.text'),
            type: 'success'
          })
          return this.$router.push({
            name: 'importerDashboard'
          })
        }
      } catch (e) {
        console.log('error')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.importer-content {
  padding-top: 40px;
  height: 100%;
}

.esign-iframe {
  width: 100%;
  height: 100%;
  border: 1px solid $gray-300;
}
</style>
